import { reorder } from './gradingschemes.js';

export default {
    'GradingSchemeTemplates/REORDER': {
        fields: ['reorder'],
        callback: async (store, mutation) => {
            await reorder(store, mutation);
        },
    },

    'GradingSchemes/REORDER': {
        fields: ['reorder'],
        callback: async (store, mutation) => {
            await reorder(store, mutation);
        },
    },
};
